<template>
  <CardModule :title="variationsTitle" class="mb-0">
    <v-row>
      <v-col cols="12">
        <VariantOption
          :option="variante"
          :idx="index"
          v-for="(variante, index) in $produtos_gerenciar.cadastro.variacoes
            .opcoes"
          :key="index"
        />
      </v-col>
    </v-row>
    <div class="produtos-add-edit-container1 row-container">
      <div class="produtos-variacoes-container">
        <v-row v-if="hasOptions" class="produtos-variacoes-container1">
          <v-btn height="45" class="button btn-border" @click="adicionarOpcao">
            <v-icon dark>
              {{ $config.icons.plus }}
            </v-icon>
            <span class="produtos-variacoes-text1">
              {{ buttonVariationText }}
            </span>
          </v-btn>
        </v-row>
        <h1
          class="produtos-add-edit-header-variacao"
          v-if="
            $produtos_gerenciar.cadastro.variacoes.variacoes_produtos.length >=
            1
          "
        >
          {{ $t("events.event-config.event-variations") }}
        </h1>
        <v-divider
          v-if="
            $produtos_gerenciar.cadastro.variacoes.variacoes_produtos.length >=
            1
          "
        ></v-divider>
        <div class="produtos-variacoes-container2" v-if="hasVariations">
          <v-checkbox
            v-model="$produtos_gerenciar.cadastro.variacoes.gerenciar_lote"
            :disabled="!hasMoreThanOneVariation"
            :label="$t('events.event-config.enable-batch-management')"
            color="tertiary"
            v-if="
              $produtos_gerenciar.cadastro.dados_cadastrais.tipo !== 'VOUCHER'
            "
          ></v-checkbox>

          <v-data-table
            class="table-body"
            mobile-breakpoint="0"
            :headers="headersVariantes"
            :items="variations"
            :items-per-page="10"
            :footer-props="{
              itemsPerPageOptions: [10, 20, 50],
              itemsPerPageText: $t('events.event-config.variations-per-page'),
            }"
          >
            <template v-slot:item.descricao="{ item }">
              {{ translateDescription(item.descricao).pt }}
            </template>
            <template v-slot:item.preco="{ item }">
              {{ item.preco ? formatCurrency(item.preco) : "R$ 0,00" }}
            </template>
            <template v-slot:item.quantidade="{ item }">
              {{
                item.quantidade || item.quantidade === 0
                  ? item.quantidade
                  : $t("events.event-config.undefined-quantity")
              }}
            </template>
            <template v-slot:item.status="{ item }">
              <v-chip
                style="color: white"
                :color="item.status === 'ATIVO' ? 'green' : 'red'"
              >
                {{ item.status }}
              </v-chip>
            </template>
            <template v-slot:item.actions="{ item }" class="table-actions">
              <div style="display: flex; justify-content: center">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      :color="$config.dados.corinputs"
                      height="30"
                      class="produtos-variacao-button1 button button-bg"
                      v-bind="attrs"
                      v-on="on"
                      width="30"
                      x-small
                      dark
                      @click="editItem(item)"
                    >
                      <EditIcon />
                    </v-btn>
                  </template>
                  <span>{{ $t("events.edit") }}</span>
                </v-tooltip>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      :color="$config.dados.corinputs"
                      height="30"
                      class="produtos-variacao-button2 button button-bg"
                      v-bind="attrs"
                      v-on="on"
                      width="30"
                      x-small
                      dark
                      :disabled="item.venda"
                      @click="deleteItem(item)"
                    >
                      <DeleteIcon />
                    </v-btn>
                  </template>
                  <span>{{ $t("events.delete") }}</span>
                </v-tooltip>
              </div>
            </template>
          </v-data-table>
        </div>
      </div>
    </div>
    <EditVariantDialog
      :dialog="dialog"
      :editedItem="editedItem"
      :editedIndex="editedIndex"
      :defaultItem="defaultItem"
      @close="dialog = false"
    />
    <ModalDeletarVariacao
      :dialogDelete="dialogDelete"
      :deletedItem="deletedItem"
      :deletedIndex="deletedIndex"
      :defaultItem="defaultItem"
      @close="dialogDelete = false"
    />
  </CardModule>
</template>

<script>
import VariantOption from "@/components/produtos/gerenciar/variants/VariantOption.vue";
import ModalDeletarVariacao from "@/components/produtos/gerenciar/variants/modal-deletar-variacao.vue";
import EditVariantDialog from "@/components/produtos/gerenciar/variants/EditVariantDialog.vue";
import EditIcon from "@/components/icons/EditIcon.vue";
import DeleteIcon from "@/components/icons/DeleteIcon.vue";
import products from "@/mixins/products.js";
import { v4 } from "uuid";
import _ from "lodash";
import { formatCurrency } from "@/utils";
import CardModule from "../../cards/CardModule.vue";
import { mapGetters, mapMutations } from "vuex";

export default {
  name: "Variants",
  mixins: [products],
  components: {
    VariantOption,
    ModalDeletarVariacao,
    EditVariantDialog,
    EditIcon,
    DeleteIcon,
    CardModule,
  },
  data() {
    return {
      formatCurrency,
      dialog: false,
      dialogDelete: false,
      editedIndex: -1,
      deletedIndex: -1,
      editedItem: {
        descricao: "",
        preco: 0,
        quantidade: 0,
        sku: 0,
        status: 0,
        idprod_var_lote: "",
        dthr_virada_lote: "",
        taxa: "",
      },
      deletedItem: {
        id_tmp: "",
        descricao: "",
        preco: 0,
        quantidade: 0,
        sku: 0,
        status: 0,
        idprod_var_lote: "",
      },
      defaultItem: {
        descricao: "",
        preco: 0,
        quantidade: 0,
        sku: 0,
        status: 0,
        idprod_var_lote: "",
      },
    };
  },
  methods: {
    /**
     * @description Método que adiciona opção de variação
     */
    ...mapMutations(["setVariations", "setOptionVariations"]),
    adicionarOpcao() {
      this.$produtos_gerenciar.cadastro.variacoes.opcoes.push({
        valor: [
          {
            tem_traducao: false,
            descricao: "",
            descricao_en_us: "",
            descricao_es_es: "",
            preco_default: "",
            qtd_default: "",
            prioridade: "",
            identificador: v4(),
            taxa: "",
            tipo: "TEXTO",
          },
        ],
      });
    },
    /**
     * @description Método que traduz descrição da variação
     */
    translateDescription(value) {
      if (
        !value.includes("<pt_BR>") ||
        !value.includes("<en_US>") ||
        !value.includes("<es_ES>")
      ) {
        return {
          pt: value,
          en: value,
          es: value,
        };
      }

      const descPT = value.substring(
        value.indexOf("<pt_BR>") + 7,
        value.indexOf("</pt_BR>")
      );
      const descEN = value.substring(
        value.indexOf("<en_US>") + 7,
        value.indexOf("</en_US>")
      );
      const descES = value.substring(
        value.indexOf("<es_ES>") + 7,
        value.indexOf("</es_ES>")
      );
      return {
        pt: descPT,
        en: descEN,
        es: descES,
      };
    },
    /**
     * @description Método que abre modal de edição de variação
     */
    editItem(item) {
      this.editedItem = item;
      this.dialog = true;
    },
    deleteItem(item) {
      this.deletedItem = item;
      this.dialogDelete = true;
    },
    closeEdit() {
      this.dialog = false;
    },
    closeDelete() {
      this.dialogDelete = false;
    },
  },
  computed: {
    ...mapGetters(["variations", "optionVariations"]),
    ticketType() {
      return (
        this.$produtos_gerenciar.cadastro.dados_cadastrais.tipo === "INGRESSO"
      );
    },
    variationsTitle() {
      return this.ticketType
        ? `${this.$t("events.event-config.create-your-tickets")}:`
        : `${this.$t("events.event-config.create-your-variations")}:`;
    },
    buttonVariationText() {
      return this.ticketType
        ? this.$t("events.event-config.add-ticket")
        : this.$t("events.event-config.add-variation");
    },
    hasOptions() {
      return (
        this.$produtos_gerenciar?.cadastro?.variacoes?.opcoes?.length === 0
      );
    },
    hasVariations() {
      return this.variations?.length > 0;
    },
    hasMoreThanOneVariation() {
      return this.variations?.length > 1;
    },
    tableValues() {
      this.$produtos_gerenciar.cadastro.variacoes.variacoes_produtos.forEach(
        item => {
          item.descricao = this.$config.convertTagString(item.descricao);
        }
      );

      return _.orderBy(
        this.$produtos_gerenciar.cadastro.variacoes.variacoes_produtos,
        "descricao"
      );
    },
  },
  watch: {
    "store.getters.optionVariations": {
      handler() {
        this.$produtos_gerenciar.cadastro.variacoes.opcoes =
          this.optionVariations;
      },
      deep: true,
    },
    variations() {
      if (
        this.$produtos_gerenciar.cadastro.variacoes.gerenciar_lote &&
        this.variations.length <= 1
      ) {
        this.$produtos_gerenciar.cadastro.variacoes.gerenciar_lote = false;
        this.$config.alert(
          this.$t("events.event-config.batch-management-warning"),
          this.$config.dados.warningColor
        );
      }
    },
    "$produtos_gerenciar.cadastro.variacoes.gerenciar_lote"(newVal) {
      if (!newVal) {
        this.$store.commit(
          "setVariations",
          this.variations.map(variation => ({
            ...variation,
            idprod_var_lote: null,
            dthr_virada_lote: null,
          }))
        );
      }
    },
  },
  mounted() {
    this.$produtos_gerenciar.tipo_variacoes =
      this.$axios.getLocal("tipos-variacoes").data;
  },
  destroyed() {
    this.$produtos_gerenciar.cadastro.variacoes.opcoes = [];
    this.$produtos_gerenciar.cadastro.variacoes.variacoes_produtos = [];
    this.setVariations([]);
    this.setOptionVariations([]);
  },
};
</script>

<style scoped>
.produtos-add-edit-header-variacao {
  width: 487px;
  font-size: 1em;
  align-self: flex-start;
  margin-top: 20px;
  padding-right: 15px;
}

.produtos-add-edit-container1 {
  width: 100%;
  display: flex;
  align-items: center;
  flex-direction: row;
  justify-content: space-between;
}

.row-container {
  flex: 0 0 auto;
  width: 100%;
  display: flex;
  margin-top: 10px;
  align-items: center;
  flex-direction: row;
  justify-content: flex-start;
}

.produtos-add-edit-container2 {
  flex: 0 0 auto;
  width: 75%;
  display: flex;
  align-items: flex-start;
  flex-direction: column;
}

.produtos-add-edit-container3 {
  flex: 0 0 auto;
  display: flex;
  align-items: center;
  border-radius: 10px;
  flex-direction: row;
  justify-content: flex-start;
  background-color: #c9c9c9;
}

.produtos-add-edit-container4 {
  flex: 0 0 auto;
  display: flex;
  align-items: center;
  flex-direction: row;
  justify-content: center;
}

.produtos-add-edit-container5 {
  flex: 0 0 auto;
  height: 50px;
  display: flex;
  align-items: center;
  padding-left: 20px;
  border-radius: 15px;
  padding-right: 20px;
  flex-direction: row;
  justify-content: center;
}

.produtos-variacoes-container {
  flex: 0 0 auto;
  width: 100%;
  height: 50%;
  display: block;
  align-items: center;
  flex-direction: column;
  justify-content: center;
}

.produtos-variacoes-container1 {
  width: 100%;
  height: auto;
  display: flex;
  align-items: center;
  margin-top: 20px;
  flex-direction: column;
  margin-bottom: 30px;
}

.produtos-variacoes-text1 {
  text-transform: initial;
}

.produtos-variacoes-container2 {
  flex: 0 0 auto;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  justify-content: flex-start;
}

.produtos-variacao-button1 {
  color: var(--dl-color-gray-white);
  height: 30px;
  display: flex;
  border-width: 0px;
  border-radius: 5px;
  flex-direction: row;
  text-decoration: none;
  background-color: var(--dl-color-gray-black);
  margin-right: 10px;
}

.produtos-variacao-button2 {
  color: var(--dl-color-gray-white);
  height: 30px;
  display: flex;
  border-width: 0px;
  border-radius: 5px;
  flex-direction: row;
  text-decoration: none;
  background-color: var(--dl-color-gray-black);
}
</style>
